











































import { Vue, Component, Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';

@Component
export default class SubAccountBody extends Vue {
  AuthInstance = getModule(AuthModule, this.$store);

  @Prop() readonly data!: object;

  @Prop() readonly lock!: Function;

  @Prop() readonly editInfo!: Function;

  @Prop() readonly resetPassword!: Function;

  @Prop() readonly editPermission!: Function;

  @Prop() readonly handleShowPermission!: Function;

  editSubAccount(id) {
    this.$router.push({ name: 'EditSubAccount', params: { id } });
  }
}
